module.exports = __webpack_public_path__ + "img/T1D_xh12.6d4bb86b.png";